<div class="row">
  <new-section [processing]="processing" (toggleCreateSection)="create($event)" (toggleCancel)="cancel()"></new-section>
</div>
